// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top_tabs {
  background: #fff3e5;
}
.top_tabs ion-buttons {
  justify-content: space-evenly;
}
.top_tabs ion-button {
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  font-weight: bold;
}
.top_tabs .selected {
  border-bottom: 2px solid #d0af93;
}
.top_tabs .toolbar-container {
  padding: 0 !important;
}

.top_chunk {
  padding: 20px;
  box-sizing: border-box;
  background: #fff3e5;
}
.top_chunk .profile_row {
  display: inline-flex;
}
.top_chunk .profile_row ion-avatar {
  margin-right: 15px;
}
.top_chunk .profile_row h3 {
  margin: 0;
  font-size: 12px;
}
.top_chunk .profile_row h4 {
  margin: 0;
  font-size: 21px;
}
.top_chunk .profile_row .stars {
  font-size: 12px;
  display: inline-flex;
  grid-gap: 4px;
}
.top_chunk .profile_row .stars ion-icon {
  font-size: 14px;
}
.top_chunk .sec_info {
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 900;
  color: #8e8e8e;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 5px;
  display: inline-flex;
  grid-gap: 15px;
}
.top_chunk .sec_info div {
  display: inline-flex;
  grid-gap: 5px;
}
.top_chunk .sec_info ion-icon {
  font-size: 14px;
  margin-top: 5px;
  color: #dbb49f;
}
.top_chunk .sec_info label {
  margin-top: 5px;
}
.top_chunk .bio {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 80%;
}

ion-content,
.user_profile_back {
  background: #fdf5e7;
  --background: #fdf5e7;
}

.bottom_chunk {
  background: #f7f7f7;
}
.bottom_chunk .cards_grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin-top: 5%;
}

ion-footer {
  position: sticky;
  bottom: 0;
}
ion-footer ion-input {
  min-width: 80%;
  margin: 0;
}

ion-card ion-avatar {
  width: 30px;
  height: 30px;
  margin-right: 14px;
  margin-top: 6px;
}

ion-popover {
  margin-top: -10vh;
  margin-left: -2vw;
  --width: 300px;
}
ion-popover .review_popover {
  width: 300px;
}
ion-popover .review_popover ion-button {
  --background: none;
  --color: #ac8875;
  font-size: 16px;
}

.send_row ion-button {
  --background: none;
  --color: #ac8875;
  font-size: 16px;
}

.lock_icon {
  font-size: 21px;
  color: #dbb49f;
  margin-top: -7px;
  margin-left: 10px;
}

.outer_loading_wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  grid-gap: 10px;
}
.outer_loading_wrap .loading_wrap {
  width: 45%;
  height: 210px;
  margin: 0;
}
.outer_loading_wrap .loading_wrap .loading_block {
  height: 210px;
}`, "",{"version":3,"sources":["webpack://./src/app/user-profile/user-profile.page.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AACI;EACI,6BAAA;AACR;AAEI;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAAR;AAGI;EACI,gCAAA;AADR;AAII;EACI,qBAAA;AAFR;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAHJ;AAKI;EACI,oBAAA;AAHR;AAKQ;EACI,kBAAA;AAHZ;AAMQ;EACI,SAAA;EACA,eAAA;AAJZ;AAOQ;EACI,SAAA;EACA,eAAA;AALZ;AAQQ;EACI,eAAA;EACA,oBAAA;EACA,aAAA;AANZ;AAQY;EACI,eAAA;AANhB;AAWI;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,oBAAA;EACA,cAAA;AAXR;AAaQ;EACI,oBAAA;EACA,aAAA;AAXZ;AAcQ;EACI,eAAA;EACA,eAAA;EACA,cAAA;AAZZ;AAeQ;EACI,eAAA;AAbZ;AAiBI;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;AAfR;;AAmBA;;EAEI,mBAAA;EACA,qBAAA;AAhBJ;;AAmBA;EACI,mBAAA;AAhBJ;AAkBI;EACI,aAAA;EACA,eAAA;EACA,6BAAA;EACA,cAAA;AAhBR;;AAoBA;EACI,gBAAA;EACA,SAAA;AAjBJ;AAmBI;EACI,cAAA;EACA,SAAA;AAjBR;;AAqBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAlBJ;;AAqBA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;AAlBJ;AAoBI;EACI,YAAA;AAlBR;AAoBQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;AAlBZ;;AAuBA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;AApBJ;;AAuBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AApBJ;;AAuBA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;AApBJ;AAsBI;EACI,UAAA;EACA,aAAA;EACA,SAAA;AApBR;AAsBQ;EACI,aAAA;AApBZ","sourcesContent":[".top_tabs {\n    background: #fff3e5;\n\n    ion-buttons {\n        justify-content: space-evenly;\n    }\n\n    ion-button {\n        font-size: 12px;\n        padding-left: 10px;\n        padding-right: 10px;\n        width: 100%;\n        font-weight: bold;\n    }\n\n    .selected {\n        border-bottom: 2px solid #d0af93;\n    }\n\n    .toolbar-container {\n        padding: 0 !important;\n    }\n}\n\n.top_chunk {\n    padding: 20px;\n    box-sizing: border-box;\n    background: #fff3e5;\n\n    .profile_row {\n        display: inline-flex;\n\n        ion-avatar {\n            margin-right: 15px;\n        }\n\n        h3 {\n            margin: 0;\n            font-size: 12px;\n        }\n\n        h4 {\n            margin: 0;\n            font-size: 21px;\n        }\n\n        .stars {\n            font-size: 12px;\n            display: inline-flex;\n            grid-gap: 4px;\n\n            ion-icon {\n                font-size: 14px;\n            }\n        }\n    }\n\n    .sec_info {\n        font-size: 12px;\n        text-transform: uppercase;\n        font-weight: 900;\n        color: #8e8e8e;\n\n        margin-top: 10px;\n        margin-bottom: 10px;\n        line-height: 5px;\n\n        display: inline-flex;\n        grid-gap: 15px;\n\n        div {\n            display: inline-flex;\n            grid-gap: 5px;\n        }\n\n        ion-icon {\n            font-size: 14px;\n            margin-top: 5px;\n            color: #dbb49f;\n        }\n\n        label {\n            margin-top: 5px;\n        }\n    }\n\n    .bio {\n        margin-top: 10px;\n        margin-bottom: 20px;\n        width: 80%;\n    }\n}\n\nion-content,\n.user_profile_back {\n    background: #fdf5e7;\n    --background: #fdf5e7;\n}\n\n.bottom_chunk {\n    background: #f7f7f7;\n\n    .cards_grid {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-evenly;\n        margin-top: 5%;\n    }\n}\n\nion-footer {\n    position: sticky;\n    bottom: 0;\n\n    ion-input {\n        min-width: 80%;\n        margin: 0;\n    }\n}\n\nion-card ion-avatar {\n    width: 30px;\n    height: 30px;\n    margin-right: 14px;\n    margin-top: 6px;\n}\n\nion-popover {\n    margin-top: -10vh;\n    margin-left: -2vw;\n    --width: 300px;\n\n    .review_popover {\n        width: 300px;\n\n        ion-button {\n            --background: none;\n            --color: #ac8875;\n            font-size: 16px;\n        }\n    }\n}\n\n.send_row ion-button {\n    --background: none;\n    --color: #ac8875;\n    font-size: 16px;\n}\n\n.lock_icon {\n    font-size: 21px;\n    color: #dbb49f;\n    margin-top: -7px;\n    margin-left: 10px;\n}\n\n.outer_loading_wrap {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    grid-gap: 10px;\n\n    .loading_wrap {\n        width: 45%;\n        height: 210px;\n        margin: 0;\n\n        .loading_block {\n            height: 210px;\n        }\n    }\n}\n\n// .square_empty_grid {\n//     display: flex;\n//     flex-wrap: wrap;\n//     justify-content: space-evenly;\n//     margin-top: 5%;\n\n//     .square {\n//         background: #f2e4da;\n//         display: block;\n//         height: 90px;\n//         width: 45%;\n//         position: relative;\n//         animation-name: barMotion;\n//         animation-duration: 1.5s;\n//         animation-iteration-count: infinite;\n//         animation-timing-function: ease-in-out;\n\n//         .inner_square {\n//             position: relative;\n//             width: 100%;\n//             height: 90px;\n//             background: #fff1e5;\n//             overflow: hidden;\n//         }\n//     }\n// }\n\n// @keyframes barMotion {\n//     0% {\n//         right: 100%;\n//     }\n\n//     50% {\n//         right: 0%;\n//     }\n\n//     100% {\n//         right: -100%;\n//     }\n// }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
